import { render, staticRenderFns } from "./data_agama.vue?vue&type=template&id=72900c9e&"
import script from "./data_agama.vue?vue&type=script&lang=js&"
export * from "./data_agama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions,QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QMarkupTable,QPagination,QDialog,QCard,QCardSection,QImg,QCardActions,QBtn})
